import { fulfilled, pending, rejected } from '../../../utils';
import { BANKS } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const bankReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(BANKS):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(BANKS):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
    case rejected(BANKS):
      const status = action.payload.response.status
      return {
          ...state,
          loading: false,
          message: '',
          error: status === 500 ? "Something went wrong. Please try again" : action.payload.response.data.message,
        };
		default:
			return state;
	}
};

export default bankReducer;
